import React, { useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";

import Button from "../../components/ui/Button";
import verify2 from "../../assets/images/common/verify2.svg";
import tickCircleGreen from "../../assets/images/common/tick-transparent.svg";

import "./index.scss";

import LeftSection from "../../components/PreLogin/LoginPage/LeftSection.js";
import RightFooter from "../../components/PreLogin/RightFooter";

import { useDispatch, useSelector } from "react-redux";
import { confirmAccount } from "../../store/actions/registerAction";

const ConfirmationForm = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();

    // Extract user_id and token from query parameters
    const user_id = new URLSearchParams(location.search).get("userid");
    const token = new URLSearchParams(location.search).get("token");

    // Get state from Redux
    const { confirmationResponse, confirmationError, loading } = useSelector((state) => state.register);

    const handleLoginRedirect = () => {
        navigate("/auth/login"); // Redirect to the login page
    };

    useEffect(() => {
        if (user_id && token) {
            // Dispatch the confirmation action
            dispatch(confirmAccount({ user_id, token }));
        } else {
            console.error("Missing user_id or token in query parameters");
        }
    }, [dispatch, user_id, token]);

    // Render loading state
    if (loading) {
        return (
            <div className="confirmation-container">
                <Row className="h-100 m-0">
                    <Col md="6">
                        <LeftSection />
                    </Col>
                    <Col md="6">
                        <div className="validated-right-section px-4 mx-3 h-100">
                            <div className="right-container text-center">
                                <img src={verify2} alt="progress" />
                                <h2>{t("Validating...")}</h2>
                            </div>
                        </div>
                        <RightFooter />
                    </Col>
                </Row>
            </div>
        );
    }

    // Render success state
    if (confirmationResponse && confirmationResponse.detail?.status === "success") {
        return (
            <div className='confirmation-container'>
            <Row className='h-100 m-0'>
                <Col md="6">
                    <LeftSection />
                </Col>
                <Col md="6">
                    <div className='validated-right-section px-4 mx-3 h-100'>
                        <div className='right-container'>
                            <div>
                                <div> <img src={verify2} alt="progress" /></div>
                                <div>  <img src={tickCircleGreen} alt="confirmation tick" /></div>
                                <h2>{t("registrationPage.accountValidated.validate")}</h2>
                                <p>{`You have successfuly validated your account.`}</p>
                                <p>{`You can now log into your account.`}</p>
                                <div className='submit-button mt-4'>
                                    <Button buttonText={"Login"} buttonType="primary" buttonClicked={handleLoginRedirect} />
                                </div>
                            </div>

                        </div>
                        <RightFooter />
                    </div>
                </Col>
            </Row>
        </div>
        );
    }

    // Render error state and stay on the same page
    if (confirmationResponse?.detail?.status === "failure" || confirmationError) {
        return (
            <div className="confirmation-container">
                <Row className="h-100 m-0">
                    <Col md="6">
                        <LeftSection />
                    </Col>
                    <Col md="6">
                        <div className="validated-right-section px-4 mx-3 h-100">
                            <div className="right-container text-center">
                                <img src={verify2} alt="error" />
                                <h2>{t("Validation Failed")}</h2>
                                <p>{confirmationError || t("Invalid user_id or token. Please try again.")}</p>
                                <p>{t("If you believe this is an error, please contact support.")}</p>
                            </div>
                        </div>
                        <RightFooter />
                    </Col>
                </Row>
            </div>
        );
    }

    return null;
};

export default ConfirmationForm;
